import React from 'react';
import SettingsIcon from '@tradera/blueprint/theme/icons2/settings.svg?jsx';

const SettingsButton = ({
    className,
    iconClassName,
    onClick,
    ...otherProps
}) => {
    return (
        <button
            className={`btn btn-round
      ${className || ''}
      `}
            onClick={onClick}
            {...otherProps}>
            <SettingsIcon className={`icon ${iconClassName || ''}`} />
        </button>
    );
};
export default SettingsButton;
